{
  "title": "Invisibility",
  "source": "Player's Handbook",
  "levelAndSchool": "2nd-level illusion",
  "level": 2,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S, M (an eyelash encased in gum arabic)",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "A creature you touch becomes invisible until the spell ends. Anything the target is wearing or carrying is invisible as long as it is on the target’s person. The spell ends for a target that attacks or casts a spell.",
    "At Higher Levels. When you cast this spell using a spell slot of 3rd level or higher, you can target one additional creature for each slot level above 2nd."
  ],
  "spellLists": ["artificer", "bard", "arcane-trickster", "sorcerer", "warlock", "wizard"]
}
